import { XlsxAdapter } from "../../adpters/XlsxAdapter/XlsxAdapter";

export class OthersContactsImportSpreadSheetRead {
    XlsxAdapter = new XlsxAdapter();
    constructor() {}

    async execute({ file }) {
        if (!file) return [];
        const data = await this.processFile({ file });
        const contacts = this.mountContactsRows(data);
        return contacts;
    }

    async processFile({ file }) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                const _parseUint8ToCharCode = (arrayBuffer) => {
                    const charCodes = [];
                    const data = new Uint8Array(arrayBuffer);

                    for (let i = 0; i <= data.length; ++i) {
                        charCodes[i] = String.fromCharCode(data[i]);
                    }

                    return charCodes;
                };
                const charCodes = _parseUint8ToCharCode(fileReader.result);
                const bstr = charCodes.join("");
                const workbook = this.XlsxAdapter.read(bstr, {
                    type: "binary",
                    raw: true,
                    cellNF: true,
                    cellFormula: true,
                    cellStyles: true
                });
                const response = this.XlsxAdapter.sheetToJson(
                    workbook.Sheets.Dados,
                    {
                        header: 1,
                        blankrows: false
                    }
                );
                resolve(response);
            };
            fileReader.readAsArrayBuffer(file);
        });
    }

    mountContactsRows(data) {
        const contactsData = data.slice(1);
        const contacts = [];
        contactsData.forEach((column) => {
            if (column[0] || column[1] || column[2]) {
                contacts.push({
                    company: { _id: column[0], name: column[0] },
                    name: column[1],
                    email: column[2]
                });
            }
        });
        return contacts;
    }
}
